import { render, staticRenderFns } from "./terminal-table.vue?vue&type=template&id=0d0affbd&scoped=true&"
import script from "./terminal-table.ts?vue&type=script&lang=ts&"
export * from "./terminal-table.ts?vue&type=script&lang=ts&"
import style0 from "./terminal-table.scss?vue&type=style&index=0&id=0d0affbd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0affbd",
  null
  
)

export default component.exports